import { BsClipboardData, BsFileEarmarkText, BsPeopleFill, BsBoxArrowRight, BsFileEarmarkWord } from 'react-icons/bs';

const NAV_ITEMS = [
  { key: 'kitoltesek',   label: 'Kitöltések',    icon: BsClipboardData },
  { key: 'szovegek',     label: 'Szövegek',       icon: BsFileEarmarkText },
  { key: 'sablonok',     label: 'Sablonok',       icon: BsFileEarmarkWord },
  { key: 'felhasznalok', label: 'Felhasználók',   icon: BsPeopleFill },
];

function Navbar({ page, setPage, onLogout }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <img
          src="https://www.presentperfect.xyz/wp-content/uploads/2018/11/pp_logo_head_mobile.png"
          alt="Present Perfect"
        />
      </div>
      <p className="sidebar-label">Navigáció</p>
      <ul className="sidebar-nav">
        {NAV_ITEMS.map(({ key, label, icon: Icon }) => (
          <li key={key}>
            <button
              className={`sidebar-nav-item${page === key ? ' active' : ''}`}
              onClick={() => setPage(key)}
            >
              <Icon />
              {label}
            </button>
          </li>
        ))}
      </ul>
      <div className="sidebar-bottom">
        <button className="sidebar-nav-item sidebar-logout" onClick={onLogout}>
          <BsBoxArrowRight />
          Kijelentkezés
        </button>
      </div>
    </aside>
  );
}

export default Navbar;
